<template>
    <svg fill="none" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 1.5h10M2 16.5h10M3 2v3.2c0 1 .35 1.95 1 2.7l3 3.6 3-3.6c.65-.75 1-1.7 1-2.7V2M3 16v-3.2c0-1 .35-1.95 1-2.7l3-3.6 3 3.6c.65.75 1 1.7 1 2.7V16"
            stroke="currentColor"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
